"use client";

import { PaperCard, type PaperCardProps } from "./PaperCard";
import { usePaperBookmarks } from "@/lib/paper-bookmarks";

export function PaperListWithBookmarks({ papers }: { papers: PaperCardProps[] }) {
  const { isPaperBookmarked, togglePaperBookmark, isLoggedIn } = usePaperBookmarks();

  return (
    <>
      {papers.map((p) => (
        <PaperCard
          key={p.pmid}
          {...p}
          isBookmarked={isPaperBookmarked(p.pmid)}
          onToggleBookmark={isLoggedIn ? togglePaperBookmark : undefined}
        />
      ))}
    </>
  );
}
